import { render, staticRenderFns } from "./AmazeUserfileVideo.vue?vue&type=template&id=38d7c27e&scoped=true"
import script from "./AmazeUserfileVideo.vue?vue&type=script&lang=js"
export * from "./AmazeUserfileVideo.vue?vue&type=script&lang=js"
import style0 from "./AmazeUserfileVideo.vue?vue&type=style&index=0&id=38d7c27e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d7c27e",
  null
  
)

export default component.exports